module.exports = __webpack_public_path__ + "img/hotel-scenic-new-list-free-tag.fdb87549.png";